/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react'
import Box from '@mui/material/Box'
import { ActivityHistoryTree } from '../ActivityHistoryTree/ActivityHistoryTree'
import { NoSelection } from '../ActivityHistoryTree/atoms/NoSelection'
import { SadMagnifyingGlassImage } from '../ActivityHistoryTree/atoms/SadMagnifyingGlassImage'
import { useSelectedFiltersCount } from '@user/features/Activity/hooks/useSelectedFiltersCount'
import { useActivitiesContext } from '@user/features/Activity/context'
import { NoResults } from '../ActivityHistoryTree/atoms/NoResults'
import { useEffect } from 'react'
import { useRefreshActivityHistory } from '@user/features/Activity/hooks/useRefreshActivityHistory'
import { ENTITY_TYPES } from '@sales-center/common'

type Props = {
  entityId: number
  entityType: ENTITY_TYPES
}

export function SearchResults(props: Props) {
  const { entityId, entityType } = props
  const selectedCount = useSelectedFiltersCount()
  const [{ history }] = useActivitiesContext()

  const { refreshHistory } = useRefreshActivityHistory(entityId, entityType)

  useEffect(() => {
    refreshHistory()
  }, [selectedCount])

  return (
    <Box sx={{ ml: 12 }}>
      {selectedCount === 0 && <NoSelection />}
      {history.length === 0 && selectedCount > 0 && <NoResults />}

      {history.length === 0 ? (
        <SadMagnifyingGlassImage />
      ) : (
        <ActivityHistoryTree />
      )}
    </Box>
  )
}
